// extracted by mini-css-extract-plugin
module.exports = {"tabSwitch":"TabSwitch_tabSwitch__2mwak","isPassive":"TabSwitch_isPassive__1XmPK","tab":"TabSwitch_tab__2Lhsn","tabTwoActive":"TabSwitch_tabTwoActive__39lVj"};